import { render } from "./EthereumRateTab.vue?vue&type=template&id=5beceabf&ts=true"
import script from "./EthereumRateTab.vue?vue&type=script&lang=ts"
export * from "./EthereumRateTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__